export default __webpack_public_path__ + "static/media/busimob-1.96bbaa46.svg";